/**
 * Created by admin on 2018/5/8.
 */
import React from 'react';
import { connect } from 'dva';
import RoomManager from '../../components/account/RoomManager';

const RoomManage = ({ account, dispatch, currentUser ,i18n:{locale}}) => {
  return (
    <RoomManager {...account} dispatch={dispatch} currentUser={currentUser} locale={locale}/>
  );
};

const mapStateToProps = state => {
  return Object.assign({}, state, {
    loading: state.loading.global,
    currentUser: state.login.userInfo
  });
};

export default connect(mapStateToProps)(RoomManage);



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/RoomManage.js